import { render, staticRenderFns } from "./editMicro.vue?vue&type=template&id=25ffd97b&scoped=true&"
import script from "./editMicro.vue?vue&type=script&lang=js&"
export * from "./editMicro.vue?vue&type=script&lang=js&"
import style0 from "./editMicro.vue?vue&type=style&index=0&id=25ffd97b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ffd97b",
  null
  
)

export default component.exports